import React, { useState } from 'react';
import { Modal } from './modal';

export function VideoContent({ videoId, thumbnailUrl }) {
  const [showVideo, setShowVideo] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showVideo ? (
        <div className="w-full mt-10 relative aspect-video block">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={'https://www.youtube-nocookie.com/embed/' + videoId}
            frameBorder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ) : (
        <div
          onClick={setShowModal.bind(null, true)}
          className="mt-10 group aspect-video relative shadow-lg cursor-pointer block"
        >
          <div className="bg-transparent w-0 h-16 border-t-[37px] border-t-transparent border-r-transparent border-r-[0px] border-b-transparent border-b-[37px] border-l-white border-l-[60px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-100 group-hover:scale-90 transition-all" />
          <img src={thumbnailUrl} alt="video thumbnail" />
        </div>
      )}

      <Modal
        fullWidth
        noIcon
        show={showModal}
        setShow={setShowModal.bind(null, false)}
        headline="An dieser Stelle befindet sich ein externes Video."
        text="YouTube Videos sind externe Inhalte. Sie können sich hier den externen Inhalt mit nur einem Klick anzeigen lassen. Durch das Anklicken des Inhalts erklären Sie sich damit einverstanden, dass Ihnen die externen Inhalte angezeigt werden. Damit können personenbezogene Daten an Drittplattformen übermittelt werden."
        buttonText="Einwilligen"
        onClose={setShowVideo.bind(null, true)}
      />
    </>
  );
}
